// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-resegment-modal-m6iTxN .semi-modal-content{color:var(--coz-fg-secondary)}.text-resegment-modal-m6iTxN .semi-modal-footer .semi-button{margin-left:16px}.text-resegment-modal-m6iTxN .text-resegment-content-VNDeQu{line-height:20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text-resegment-modal": `text-resegment-modal-m6iTxN`,
	"textResegmentModal": `text-resegment-modal-m6iTxN`,
	"text-resegment-content": `text-resegment-content-VNDeQu`,
	"textResegmentContent": `text-resegment-content-VNDeQu`
};
export default ___CSS_LOADER_EXPORT___;
